import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState, useEffect } from "react";

var useFragmentFetch = function useFragmentFetch(url, options) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      response = _useState2[0],
      setResponse = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var fetchData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fetchResponse, fetchErr, fetchError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url, options);

            case 3:
              fetchResponse = _context.sent;

              if (fetchResponse.ok) {
                _context.next = 10;
                break;
              }

              fetchErr = {
                code: fetchResponse.status,
                err: new Error(fetchResponse.statusText)
              };
              setError(fetchErr);
              setIsLoading(false);
              _context.next = 17;
              break;

            case 10:
              setError(null);
              _context.t0 = setResponse;
              _context.next = 14;
              return fetchResponse.json();

            case 14:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              setIsLoading(false);

            case 17:
              _context.next = 24;
              break;

            case 19:
              _context.prev = 19;
              _context.t2 = _context["catch"](0);
              fetchError = {
                err: _context.t2
              };
              setError(fetchError);
              setIsLoading(false);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 19]]);
    }));

    return function fetchData() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchData();
  }, [url]);
  return [response, isLoading, error];
};

export default useFragmentFetch;